import { render, staticRenderFns } from "./DuelsFilterCount.vue?vue&type=template&id=5e609e04&scoped=true"
import script from "./DuelsFilterCount.vue?vue&type=script&lang=js"
export * from "./DuelsFilterCount.vue?vue&type=script&lang=js"
import style0 from "./DuelsFilterCount.vue?vue&type=style&index=0&id=5e609e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e609e04",
  null
  
)

export default component.exports